import AccessTimeIcon from '@mui/icons-material/AccessTime';
import AppsIcon from '@mui/icons-material/Apps';
import GroupIcon from '@mui/icons-material/Group';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import WifiIcon from '@mui/icons-material/Wifi';
import ForumIcon from '@mui/icons-material/Forum';
import NotificationsIcon from '@mui/icons-material/Notifications';
import LocalActivityIcon from '@mui/icons-material/LocalActivity';
import GroupsIcon from '@mui/icons-material/Groups';
import NewspaperIcon from '@mui/icons-material/Newspaper';
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';
import AssignmentIcon from '@mui/icons-material/Assignment';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import PollIcon from '@mui/icons-material/Poll';
import VideoCameraFrontIcon from '@mui/icons-material/VideoCameraFront';
import ConnectWithoutContactIcon from '@mui/icons-material/ConnectWithoutContact';
import Article from '@mui/icons-material/Article';
import FaqIcon from '@mui/icons-material/QuestionMark';
import CampaignIcon from '@mui/icons-material/Campaign';
import ColorLensIcon from '@mui/icons-material/ColorLens';
import InsertLinkIcon from '@mui/icons-material/InsertLink';
import VideocamIcon from '@mui/icons-material/Videocam';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import StadiumIcon from '@mui/icons-material/Stadium';
import InfoIcon from '@mui/icons-material/Info';
import ImportContactsIcon from '@mui/icons-material/ImportContacts';
import NewReleasesIcon from '@mui/icons-material/NewReleases';
import svStrings from '../../sv-strings';
import { SxStyle } from '../../types';
import { FOTBOLL_PLAY_TEAM_ADMIN_ABBRVS } from '../scenes/fotbollplay/access';

const { REACT_APP_DEFAULT_LEAGUE_SEASON } = process.env;

export enum MenuVariant {
  ITEM,
  TEAM_GROUP,
  SUB_MENU,
}

export enum MenuPermission {
  SUPER_ADMIN,
  TEAM_ADMIN,
  STATS_ADMIN,
}

export interface MenuItem {
  variant: MenuVariant;
  id: string;
  text: string;
  icon?: JSX.Element;
  to?: string;
  isLink?: boolean;
  menuItems?: MenuItem[];
  permissions?: MenuPermission[];
  allowedTeamAbbrvs?: string[];
}

const styles: SxStyle = {
  icon: {
    width: '16px',
    height: '16px',
  },
};

export const menuItems: MenuItem[] = [
  {
    variant: MenuVariant.TEAM_GROUP,
    id: 'app-content',
    text: svStrings.menu.appContent,
    permissions: [MenuPermission.SUPER_ADMIN, MenuPermission.TEAM_ADMIN],
    menuItems: [
      {
        variant: MenuVariant.ITEM,
        id: 'scene-config',
        to: '/scene-config/abbrv',
        text: svStrings.menu.sceneConfigs,
        icon: <AppsIcon sx={styles.icon} />,
        permissions: [MenuPermission.SUPER_ADMIN, MenuPermission.TEAM_ADMIN],
      },
      {
        variant: MenuVariant.ITEM,
        id: 'news',
        to: '/news/abbrv',
        text: svStrings.menu.news,
        icon: <NewspaperIcon sx={styles.icon} />,
        permissions: [
          MenuPermission.SUPER_ADMIN,
          MenuPermission.SUPER_ADMIN,
          MenuPermission.TEAM_ADMIN,
        ],
      },
      {
        variant: MenuVariant.ITEM,
        id: 'promos',
        to: '/promos/abbrv',
        text: svStrings.menu.promos,
        icon: <CampaignIcon sx={styles.icon} />,
        permissions: [MenuPermission.SUPER_ADMIN, MenuPermission.TEAM_ADMIN],
      },
      {
        variant: MenuVariant.ITEM,
        id: 'articles',
        to: '/articles/abbrv',
        text: svStrings.menu.articles,
        icon: <Article sx={styles.icon} />,
        permissions: [
          MenuPermission.SUPER_ADMIN,
          MenuPermission.SUPER_ADMIN,
          MenuPermission.TEAM_ADMIN,
        ],
      },
      {
        variant: MenuVariant.ITEM,
        id: 'fotbollplay',
        to: '/fotbollplay/abbrv',
        text: 'Play',
        icon: <CampaignIcon sx={styles.icon} />,
        permissions: [MenuPermission.SUPER_ADMIN, MenuPermission.TEAM_ADMIN],
        allowedTeamAbbrvs: [...FOTBOLL_PLAY_TEAM_ADMIN_ABBRVS],
      },
      {
        variant: MenuVariant.ITEM,
        id: 'polls',
        to: '/polls/abbrv',
        text: svStrings.menu.polls,
        icon: <PollIcon sx={styles.icon} />,
        permissions: [MenuPermission.SUPER_ADMIN, MenuPermission.TEAM_ADMIN],
      },
      {
        variant: MenuVariant.ITEM,
        id: 'stories',
        to: '/stories/abbrv',
        text: svStrings.menu.videoPortraits,
        icon: <VideoCameraFrontIcon sx={styles.icon} />,
        permissions: [MenuPermission.SUPER_ADMIN, MenuPermission.TEAM_ADMIN],
      },
      {
        variant: MenuVariant.ITEM,
        id: 'pushdashboard',
        to: '/pushdashboard/abbrv',
        text: svStrings.menu.pushDashboard,
        icon: <NotificationsIcon sx={styles.icon} />,
        permissions: [
          MenuPermission.SUPER_ADMIN,
          MenuPermission.SUPER_ADMIN,
          MenuPermission.TEAM_ADMIN,
        ],
      },
    ],
  },
  {
    variant: MenuVariant.TEAM_GROUP,
    id: 'app-settings-theme',
    text: svStrings.menu.appSettingsTheme,
    permissions: [MenuPermission.SUPER_ADMIN, MenuPermission.TEAM_ADMIN],
    menuItems: [
      {
        variant: MenuVariant.ITEM,
        id: 'theme',
        to: '/theme/abbrv',
        text: svStrings.menu.theme,
        icon: <ColorLensIcon sx={styles.icon} />,
        permissions: [MenuPermission.SUPER_ADMIN, MenuPermission.TEAM_ADMIN],
      },
      {
        variant: MenuVariant.ITEM,
        id: 'app-menu',
        to: '/app-menu/abbrv',
        text: svStrings.menu.appMenu,
        icon: <AppsIcon sx={styles.icon} />,
        permissions: [MenuPermission.SUPER_ADMIN, MenuPermission.TEAM_ADMIN],
      },
      {
        variant: MenuVariant.ITEM,
        id: 'links-info',
        to: '/links-info/abbrv',
        text: svStrings.menu.linksInfo,
        icon: <InsertLinkIcon sx={styles.icon} />,
        permissions: [MenuPermission.SUPER_ADMIN, MenuPermission.TEAM_ADMIN],
      },
      {
        variant: MenuVariant.ITEM,
        id: 'video-branding',
        to: '/video-branding/abbrv',
        text: svStrings.menu.videoPlayer,
        icon: <VideocamIcon sx={styles.icon} />,
        permissions: [MenuPermission.SUPER_ADMIN, MenuPermission.TEAM_ADMIN],
      },
      {
        variant: MenuVariant.ITEM,
        id: 'support',
        to: '/support/abbrv',
        text: svStrings.menu.support,
        icon: <SupportAgentIcon sx={styles.icon} />,
        permissions: [MenuPermission.SUPER_ADMIN, MenuPermission.TEAM_ADMIN],
      },
    ],
  },
  {
    variant: MenuVariant.TEAM_GROUP,
    id: 'team-arena',
    text: svStrings.menu.teamArena,
    permissions: [MenuPermission.SUPER_ADMIN, MenuPermission.TEAM_ADMIN],
    menuItems: [
      {
        variant: MenuVariant.ITEM,
        id: 'squad',
        to: '/squad/abbrv',
        text: svStrings.menu.squad,
        icon: <GroupsIcon sx={styles.icon} />,
        permissions: [MenuPermission.SUPER_ADMIN, MenuPermission.TEAM_ADMIN],
      },
      {
        variant: MenuVariant.ITEM,
        id: 'staff',
        to: `/staff/abbrv/${REACT_APP_DEFAULT_LEAGUE_SEASON}`,
        text: svStrings.menu.staff,
        icon: <SupervisorAccountIcon sx={styles.icon} />,
        permissions: [MenuPermission.SUPER_ADMIN],
      },
      {
        variant: MenuVariant.ITEM,
        id: 'arena',
        to: '/arena/abbrv',
        text: svStrings.menu.arena,
        icon: <StadiumIcon sx={styles.icon} />,
        permissions: [MenuPermission.SUPER_ADMIN, MenuPermission.TEAM_ADMIN],
      },
      {
        variant: MenuVariant.ITEM,
        id: 'team-data',
        to: '/team-data/abbrv',
        text: svStrings.menu.teamData,
        icon: <InfoIcon sx={styles.icon} />,
        permissions: [MenuPermission.SUPER_ADMIN],
      },
    ],
  },
  {
    variant: MenuVariant.ITEM,
    id: 'social-interaction',
    to: '/social-interaction/abbrv',
    text: svStrings.menu.socialInteractions,
    icon: <ConnectWithoutContactIcon sx={styles.icon} />,
    permissions: [MenuPermission.SUPER_ADMIN, MenuPermission.TEAM_ADMIN],
  },

  {
    variant: MenuVariant.ITEM,
    id: 'matches',
    to: '/matches/abbrv',
    text: svStrings.menu.matches,
    icon: <SportsSoccerIcon sx={styles.icon} />,
    permissions: [MenuPermission.SUPER_ADMIN, MenuPermission.STATS_ADMIN],
  },
  {
    variant: MenuVariant.SUB_MENU,
    id: 'administration',
    text: svStrings.menu.superAdmin,
    permissions: [MenuPermission.SUPER_ADMIN],
    menuItems: [
      {
        variant: MenuVariant.ITEM,
        id: 'all-players',
        to: `/all-players/${REACT_APP_DEFAULT_LEAGUE_SEASON}`,
        text: svStrings.menu.allPlayers,
        icon: <GroupsIcon sx={styles.icon} />,
        permissions: [MenuPermission.SUPER_ADMIN],
      },
      {
        variant: MenuVariant.ITEM,
        id: 'mappings',
        to: '/mappings',
        text: svStrings.menu.mappings,
        icon: <AssignmentIcon sx={styles.icon} />,
      },
      {
        variant: MenuVariant.ITEM,
        id: 'ticket-config',
        to: '/ticket-config',
        text: svStrings.menu.ticketConfigurator,
        icon: <LocalActivityIcon sx={styles.icon} />,
      },
      {
        variant: MenuVariant.ITEM,
        id: 'wifi',
        to: '/wifi/network',
        text: svStrings.menu.wifi,
        icon: <WifiIcon sx={styles.icon} />,
      },
      {
        variant: MenuVariant.ITEM,
        id: 'time-machine',
        to: '/time-machine',
        text: svStrings.menu.timeMachine,
        icon: <AccessTimeIcon sx={styles.icon} />,
      },
      {
        variant: MenuVariant.ITEM,
        id: 'message-viewer',
        to: '/message-viewer',
        text: svStrings.menu.messageViewer,
        icon: <ForumIcon sx={styles.icon} />,
      },
      {
        variant: MenuVariant.ITEM,
        id: 'user',
        to: '/user',
        text: svStrings.menu.userExplorer,
        icon: <PersonSearchIcon sx={styles.icon} />,
      },
      {
        variant: MenuVariant.ITEM,
        id: 'faq',
        to: '/faq',
        text: svStrings.menu.faq,
        icon: <FaqIcon sx={styles.icon} />,
      },
      {
        variant: MenuVariant.ITEM,
        id: 'announcements',
        to: `/announcements`,
        text: svStrings.menu.announcements,
        icon: <NewReleasesIcon sx={styles.icon} />,
        permissions: [MenuPermission.SUPER_ADMIN],
      },
    ],
  },
  {
    variant: MenuVariant.SUB_MENU,
    id: 'user-and-manual',
    text: svStrings.menu.userAndManual,
    permissions: [MenuPermission.SUPER_ADMIN],
    menuItems: [
      {
        variant: MenuVariant.ITEM,
        id: 'users-and-permissions',
        to: '/users-and-permissions',
        text: svStrings.menu.usersAndPermissions,
        icon: <GroupIcon sx={styles.icon} />,
        permissions: [MenuPermission.SUPER_ADMIN, MenuPermission.TEAM_ADMIN],
      },
      {
        variant: MenuVariant.ITEM,
        id: 'manual',
        to: process.env.REACT_APP_USER_MANUAL_URL || '',
        text: svStrings.menu.userManual,
        icon: <ImportContactsIcon sx={styles.icon} />,
        isLink: true,
        permissions: [MenuPermission.SUPER_ADMIN, MenuPermission.TEAM_ADMIN],
      },
    ],
  },
];
